import { useTranslation } from 'react-i18next';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { useWidgetVisibility } from '../../../hooks/useWidgetVisibility.ts';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { getWidgetProps } from '../../inputs/common/util/getWidgetProps.ts';
import { type IDividerWidget } from './IDividerWidget.ts';
import { TitleDivider } from './style/TitleDivider.tsx';

export interface IDividerWidgetComponentProps
  extends IWidgetComponentProps<IDividerWidget> {}

export function DividerWidgetComponent(props: IDividerWidgetComponentProps) {
  const options = getWidgetProps(props);

  const { t } = useTranslation();
  const visible = useWidgetVisibility(props.widget, options);

  if (!visible) return null;

  return (
    <TitleDivider>
      <RichTextAdvancedRender
        hasCustomFont
        text={
          props.widget.title ??
          (options.preview
            ? [
                {
                  type: 'text',
                  text: t(
                    'divider-widget.new-divider-title',
                    'Nuovo titolo divisore',
                  ),
                },
              ]
            : [])
        }
      />
    </TitleDivider>
  );
}
